import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { horseSelectRippleOptions } from '../../constants/ripple-options.constant';
import { Partant } from '../../models/partant.model';
import { Game, GameFormula } from '../../models/game.model';
import { canSelectMoreAssociates, canSelectMorePartants } from '../../functions/partant-selection-validation.function';

@Component({
  selector: 'app-horse-list',
  imports: [FormsModule, TranslateModule, MatRippleModule],
  templateUrl: './horse-list.component.html',
  styleUrl: './horse-list.component.scss',
})
export class HorseListComponent implements OnInit, OnChanges {
  voirDetails = false;
  @Input() horses: Partant[] = [];
  @Input() selectedFormula : GameFormula = 'SI';
  @Input() isCFEnabled: boolean = false;
  @Input() baseHorseCount: number = 0;
  @Input() maxHorseCount: number = 0;
  @Input() isSpot: boolean = false;
  @Output() selectHorse = new EventEmitter<{base: string[], associes: string[]}>();
  @Output() togglePartantDetails = new EventEmitter<boolean>();
  showAssociates: boolean = false;
  isBase: boolean = true;
  isAssociates: boolean = false;
  @Input() set showAssociateSelect(value: boolean) {
    // this.voirDetails = value;
    this.showAssociates = value;
  }
  @Input() set showListDetails(value: boolean) {
    this.voirDetails = value;
  }
  baseSelectees: string[] = [];
  associateSelectees: string[] = [];
  rippleOptions = horseSelectRippleOptions
  get stepNumber() {
    return 2;
  }
  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedFormula'] || changes['horses']){
      this.horses.forEach((horse) => {
        horse.selectionne = false;
        horse.associe = false;
      });
      this.baseSelectees = [];
      this.associateSelectees = [];

      if(['CP', 'CT'].includes(changes['selectedFormula'].currentValue)){
        this.toggleSelectionType('base');
      }
    }
  }

  toggleSelection(horse: Partant) {
    horse.selectionne = !horse.selectionne;
  }

  get isCP(){
    return this.selectedFormula === 'CP';
  }

  setFavori(horse: Partant) {
    this.horses.forEach((c) => (c.favori = 0));
    horse.favori = 1;
  }

  toggleDetails() {
    this.voirDetails = !this.voirDetails;
    this.togglePartantDetails.emit(this.voirDetails)
  }

  selectPartant(selected: boolean, index: number, isAssociate: boolean) {
    this.horses[index].selectionne = selected && !isAssociate;
    this.horses[index].associe = selected && isAssociate;
    const horseNumber = this.horses[index].numero.toString();

    if (selected) {
        if (isAssociate) {
            if (!this.associateSelectees.includes(horseNumber)) {
                this.associateSelectees.push(horseNumber);
            }
        } else {
            if (!this.baseSelectees.includes(horseNumber)) {
                this.baseSelectees.push(horseNumber);
            }
        }
    } else {
        if (isAssociate) {
            this.associateSelectees = this.associateSelectees.filter(num => num !== horseNumber);
        } else {
            this.baseSelectees = this.baseSelectees.filter(num => num !== horseNumber);
        }
    }

    const [base, associes] = [this.baseSelectees, this.associateSelectees];
    this.selectHorse.emit({ base, associes });
  }

  addXToBaseSelections() {
    const [baseCount, maxCount] = [this.baseHorseCount, this.maxHorseCount];
    if (this.baseSelectees.length < maxCount) {
      let baseHorses = this.baseSelectees;
      baseHorses.push("X");
      const [base, associes] = [baseHorses, this.associateSelectees];
    this.selectHorse.emit({ base, associes });

    }
  }

  disablePartantSelection(_t8: Partant) {
    // Disable selection if horse is not partant or has already been selected
    if (['non-partant', 'non partant'].some(status => new RegExp(status, 'i').test(_t8.status.toLowerCase())) || _t8.associe) return true;

    return !canSelectMorePartants(this.baseSelectees.length, this.baseHorseCount, (this.maxHorseCount || this.partantHorses.length), this.selectedFormula) && !this.baseSelectees.includes(_t8.numero);
  }

  get partantHorses(){
    return this.horses.filter((h) => !h.status.toLowerCase().includes('non'));
  }

  disableAssoSelection(_t34: Partant): boolean {
    if (['non-partant', 'non partant'].some(status => new RegExp(status, 'i').test(_t34.status.toLowerCase())) || _t34.selectionne) return true;
    return !canSelectMoreAssociates(this.baseSelectees.length, this.associateSelectees.length, this.baseHorseCount, (this.maxHorseCount || this.partantHorses.length), this.selectedFormula) && !this.associateSelectees.includes(_t34.numero);
  }

  // method to clear selections in HorseListComponent
  clearAllSelections() {
    this.horses.forEach((horse) => {
      horse.selectionne = false;
      horse.associe = false;
    });
    this.baseSelectees = [];
    this.associateSelectees = [];
    this.selectHorse.emit({ base: [], associes: [] });
  }

  toggleSelectionType(type: string) {
    switch (type) {
      case 'base':
        this.isBase = true;
        this.isAssociates = false;
        break;
      case 'associates':
        this.isBase = false;
        this.isAssociates = true;
        break;
      default:
        break;
    }
  }

}
